import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Customer } from "@src/app/components/org/orgprojectadd/model/customer";
import { AuthorizationService } from "@src/app/helpers/authorization.service";
import { CustomerUser } from "@src/app/models/customeruser";
import { CustomerusercreateService } from "./service/customerusercreate.service";
import { SessionHelper } from "@src/app/helpers/sessionHelper";

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-customerusercreate",
  templateUrl: "./customerusercreate.component.html",
  styleUrls: ["./customerusercreate.component.css"],
})
export class CustomerusercreateComponent implements OnInit {
  createCustomerUser: CustomerUser;
  errorMessage: string;
  showSpinner: boolean;
  formIsValid: boolean;
  @Output() userfieldValidator:boolean = false;
  @Output() emailfieldValidator:boolean = false;
  @Input() light: boolean;
  @Input() customer: Customer;
  @Output() userToAdd = new EventEmitter<CustomerUser>();

  @ViewChild("closemodal", { static: true }) closemodal: ElementRef;

  constructor(
    private cucsrv: CustomerusercreateService,
    private auth: AuthorizationService
  ) {}

  canCreate() {
    return this.auth.isAuthorized("orgedit", this.customer.organizationId);
  }
  ngOnInit() {
    this.createCustomerUser = new CustomerUser();
    this.createCustomerUser.isactive = false;
  }
  onCreate() {
    //creation of the customer user in cognoto happens on the backend
    //and the userId is returned to the frontend
    this.showSpinner = true;

    this.errorMessage = null;
    this.createCustomerUser.creator = SessionHelper.getUserSub();
    this.createCustomerUser.customerId = this.customer.customerId.substr(0, 36);
    this.createCustomerUser.userrole = "user";
    this.createCustomerUser.userId = null;
    this.createCustomerUser.created = new Date().toISOString();
    this.createCustomerUser.organizationId = this.customer.organizationId;
    //this.createCustomerUser.isactive = true;

    this.cucsrv.addCustomerUser(this.createCustomerUser).pipe(untilDestroyed(this)).subscribe((userId) => {
      //console.log('User id added: ',user);
      this.createCustomerUser.userId = userId;
      this.createCustomerUser.validto = new Date("9999-01-01").toISOString();
      this.createCustomerUser.phone = "";
      this.userToAdd.emit(this.createCustomerUser);
      this.createCustomerUser = new CustomerUser();
      this.showSpinner = false;
      this.closemodal.nativeElement.click();
    });
  }
  validate() {
    if (
      this.createCustomerUser.fullname &&
      this.createCustomerUser.jobtitle &&
      this.createCustomerUser.email &&
      this.userfieldValidator &&
      this.emailfieldValidator &&
      this.createCustomerUser.email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ) &&
      this.createCustomerUser.username &&
      !this.createCustomerUser.username.includes('/') &&
      !this.createCustomerUser.email.includes('/')
    ) {
      this.formIsValid = true;
    } else {
      this.formIsValid = false;
    }
  }
  onUsernameChange(value){
    if(!value.includes('/')){
      this.userfieldValidator = true;
    }else{
      this.userfieldValidator = false;
    }
  }
  onEmailChange(value){
    if(!value.includes('/')){
      this.emailfieldValidator = true;
    }else{
      this.emailfieldValidator = false;
    }
  }

  activeusertoggle(){
    this.createCustomerUser.isactive =! this.createCustomerUser.isactive;
  }
  sendinvitetogge(){
    this.createCustomerUser.sendinvite =! this.createCustomerUser.sendinvite;
  }
}
